import styled from "styled-components";
import { useState, useEffect } from "react";
import FormCheckBox from "../../../../../components/FormControls/FormCheckBox";
import FormStringInput from "../../../../../components/FormControls/FormStringInput";
import FormNumberInput from "../../../../../components/FormControls/FormNumberInput";
import PrimaryButton from "../../../../../components/FormControls/PrimaryButton";
import request from "../../../../../api/request";
import { updateObject } from "../../../../../utils/object";
import { NotificationManager } from 'react-notifications';

const StyledMainSystemSettings = styled.div`
    margin-left: 30px;
`;

const SettingsBoard = styled.div`
    background-color: white;
    width: 755px;
    box-sizing: border-box;
    min-height: 400px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

const Title = styled.span`
    display: block;
    color: ${(props) => props.theme.color.primaryblue};
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 5px;
`;

function MainSystemSettings(props) {

    const [isSaving, setIsSaving] = useState(false);
    const [isTestSystem, setIsTestSystem] = useState(false);
    const [passwordExpirationDays, setPasswordExpirationDays] = useState(365);
    const [supportEmail, setSupportEmail] = useState('');
    const [websiteURL, setWebsiteURL] = useState('');

    const onSaveChanges = async () => {
        setIsSaving(true);
        let saveData = {
            IsTestSystem: isTestSystem,
            PasswordExpiresInDays: passwordExpirationDays,
            SupportEmail: supportEmail,
            WebSiteUrl: websiteURL
        }
        const resp = (await request('database', 'saveSettings', [saveData]));
        if (resp.ok) {
            updateObject(props.settings, saveData);
            props.setSettings(props.settings);
            NotificationManager.success('System settings saved');
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsSaving(false);
    };

    useEffect(() => {
        props.setPageTitle('Main system');
        setIsTestSystem(props.settings.IsTestSystem || false);
        setPasswordExpirationDays(props.settings.PasswordExpiresInDays || 365);
        setSupportEmail(props.settings.SupportEmail || '');
        setWebsiteURL(props.settings.WebSiteUrl || '');
    }, [])

    return (
        <StyledMainSystemSettings>
            <SettingsBoard>
                <Title>Details</Title>
                <div style={{paddingTop: 5}}>
                    <FormCheckBox label='Is test system?' checked={isTestSystem} onCheck={setIsTestSystem}>
                    </FormCheckBox>
                </div>
                <FormNumberInput label='Password expiration period' value={passwordExpirationDays} suffix='days' min='1' onChange={setPasswordExpirationDays} inputStyle={{width:85}}></FormNumberInput>
                <FormStringInput label='Support email' placeholder='systemsupport@clientname.com' value={supportEmail} onChange={setSupportEmail} inputStyle={{width:250}}></FormStringInput>
                <FormStringInput label='Website URL' placeholder='https://companyadmin.com' value={websiteURL} onChange={setWebsiteURL} inputStyle={{width:250}}></FormStringInput>
            </SettingsBoard>
            <div style={{float: 'right'}}>
                <PrimaryButton caption='Save changes' isLoading={isSaving} onClick={onSaveChanges}>
                </PrimaryButton>
            </div>
        </StyledMainSystemSettings>
    )
}

export default MainSystemSettings;